import {
  Component,
  computed,
  EventEmitter,
  inject,
  input,
  Output,
} from '@angular/core';
import { ENVIRONMENT_CONFIG } from '@core/config-angular';
import type { StreetAddress } from '@essent/new-customer';
import type { Offer } from '@innogy/become-a-customer/shared/interfaces';
import { ConsumptionValuesVM } from '@innogy/become-a-customer/shared/interfaces';
import type { CurrentContract } from '@innogy/retention/store';
import { InnogyComponentRendering } from '@core/jss-models';

import type { CommodityOfferContent } from '../commodity-offers.model';

@Component({
  selector: 'wl-horizontal-commodity-offer',
  templateUrl: './horizontal-commodity-offer.component.html',
})
export class HorizontalCommodityOfferComponent {
  readonly offers = input<Offer[]>();
  readonly rendering = input<InnogyComponentRendering>();
  readonly content = input<CommodityOfferContent>();
  readonly showMemberGetMember = input<boolean>(false);
  readonly consumptionValues = input<ConsumptionValuesVM>();
  readonly supplyAddress = input<Partial<StreetAddress>>();
  readonly accountId = input<string>();
  readonly flowId = input<string>();
  readonly currentContract = input<CurrentContract>();

  readonly envConfig = inject(ENVIRONMENT_CONFIG);

  @Output() selectOffer = new EventEmitter<Offer>();
  @Output() openMoreInfo = new EventEmitter<Offer>();
  @Output() viewTariffs = new EventEmitter<Offer>();
  @Output() adjustCalculation = new EventEmitter<void>();

  readonly availableCurrentContract = computed(() => {
    if (
      this.content()?.showMyContract &&
      this.envConfig.segment === 'consument' &&
      this.currentContract()
    ) {
      return this.currentContract();
    } else {
      return null;
    }
  });
}
